import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, Brain, Settings, Heart } from 'lucide-react';
export function WhyItHappensSection() {
  return <section className="py-20 bg-stone-50" data-id="element-249">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-250">
        <div className="text-center mb-16" data-id="element-251">
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 mb-4" data-id="element-252">
            El error #1 que dispara el caos diario
          </h2>
          <p className="text-xl text-stone-600 mb-8" data-id="element-253">
            Casi todos los padres cometen el mismo error sin darse cuenta:
          </p>
          <div className="inline-block bg-white px-8 py-4 rounded-2xl shadow-sm border border-stone-200 transform -rotate-1" data-id="element-254">
            <span className="text-4xl md:text-5xl font-black text-amber-500 tracking-tight" data-id="element-255">
              Piden sin mostrar.
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 max-w-5xl mx-auto mb-16" data-id="element-256">
          {/* Left Column: The Mistake */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-red-50 p-8 rounded-3xl border-l-8 border-red-400 shadow-sm" data-id="element-257">
            <h3 className="text-xl font-bold text-red-800 mb-6 uppercase tracking-wide" data-id="element-258">
              Lo que dices:
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-259">
              <li className="flex items-start gap-3" data-id="element-260">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-261" />
                <span className="text-lg text-stone-700 font-medium italic" data-id="element-262">
                  «Primero los zapatos, después la mochila, luego la campera, y
                  apúrate...»
                </span>
              </li>
            </ul>
            <div className="bg-white/60 p-4 rounded-xl" data-id="element-263">
              <p className="text-stone-800 font-semibold" data-id="element-264">
                El resultado:{' '}
                <span className="font-normal text-stone-600" data-id="element-265">
                  El niño se queda quieto. Se distrae. Se frustra. Explota.
                </span>
              </p>
            </div>
          </motion.div>

          {/* Right Column: The Reason */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-blue-50 p-8 rounded-3xl border-l-8 border-blue-400 shadow-sm" data-id="element-266">
            <h3 className="text-xl font-bold text-blue-800 mb-6 uppercase tracking-wide" data-id="element-267">
              Por qué pasa:
            </h3>
            <p className="text-stone-700 mb-4" data-id="element-268">
              El cerebro infantil todavía está desarrollando su equipo interno:
            </p>
            <ul className="space-y-3 mb-6" data-id="element-269">
              <li className="flex items-center gap-3 text-stone-700 font-medium" data-id="element-270">
                <Brain className="w-5 h-5 text-blue-500" data-id="element-271" />
                Memoria de trabajo
              </li>
              <li className="flex items-center gap-3 text-stone-700 font-medium" data-id="element-272">
                <Settings className="w-5 h-5 text-blue-500" data-id="element-273" />
                Función ejecutiva
              </li>
              <li className="flex items-center gap-3 text-stone-700 font-medium" data-id="element-274">
                <Heart className="w-5 h-5 text-blue-500" data-id="element-275" />
                Autorregulación
              </li>
            </ul>
            <div className="bg-white/60 p-4 rounded-xl" data-id="element-276">
              <p className="text-stone-800 font-semibold italic" data-id="element-277">
                En momentos de estrés, las palabras se evaporan. Las imágenes se
                quedan.
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-emerald-500 text-white rounded-3xl p-8 md:p-12 text-center max-w-4xl mx-auto shadow-xl" data-id="element-278">
          <p className="text-2xl md:text-3xl mb-2 opacity-90" data-id="element-279">
            La solución no es hablar más.
          </p>
          <p className="text-3xl md:text-4xl font-black tracking-tight" data-id="element-280">
            La solución es mostrar mejor.
          </p>
        </motion.div>
      </div>
    </section>;
}